/**
 * @generated SignedSource<<b064aaa07b49efad78936298f8cfc455>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type OfflineLicenseTokenRequestStatus = "NONE" | "REQUESTED" | "%future added value";
export type AppOfflineLicenseTokenSectionQuery$variables = {
  appId: string;
};
export type AppOfflineLicenseTokenSectionQuery$data = {
  readonly viewer: {
    readonly appById: {
      readonly id: string;
      readonly isOfflineLicenseEligible: boolean;
      readonly licenses: ReadonlyArray<{
        readonly expiresAt: string | null | undefined;
        readonly id: string;
        readonly token: string;
      }>;
      readonly offlineLicenseRequestStatus: OfflineLicenseTokenRequestStatus;
    } | null | undefined;
  };
};
export type AppOfflineLicenseTokenSectionQuery = {
  response: AppOfflineLicenseTokenSectionQuery$data;
  variables: AppOfflineLicenseTokenSectionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "appId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Viewer",
    "kind": "LinkedField",
    "name": "viewer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "appId"
          }
        ],
        "concreteType": "App",
        "kind": "LinkedField",
        "name": "appById",
        "plural": false,
        "selections": [
          (v1/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "License",
            "kind": "LinkedField",
            "name": "licenses",
            "plural": true,
            "selections": [
              (v1/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "expiresAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "token",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "offlineLicenseRequestStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isOfflineLicenseEligible",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AppOfflineLicenseTokenSectionQuery",
    "selections": (v2/*:: as any*/),
    "type": "QueryRoot",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "AppOfflineLicenseTokenSectionQuery",
    "selections": (v2/*:: as any*/)
  },
  "params": {
    "cacheID": "dd69f1585f1ea3dc3662ecc43fc8c5e9",
    "id": null,
    "metadata": {},
    "name": "AppOfflineLicenseTokenSectionQuery",
    "operationKind": "query",
    "text": "query AppOfflineLicenseTokenSectionQuery(\n  $appId: ID!\n) {\n  viewer {\n    appById(id: $appId) {\n      id\n      licenses {\n        id\n        expiresAt\n        token\n      }\n      offlineLicenseRequestStatus\n      isOfflineLicenseEligible\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "53a74c5b183bda30b09821637a1d7715";

export default node;
